// Simple Set to track active job request uploads in the current session
const activeUploads = new Set();

export const addActiveUpload = (id) => {
  if (id) {
    const strId = String(id);
    activeUploads.add(strId);
    // eslint-disable-next-line no-console
    console.log(`[ActiveUploads] Added active upload: ${strId}`, activeUploads);
  }
};

export const removeActiveUpload = (id) => {
  if (id) {
    const strId = String(id);
    activeUploads.delete(strId);
    // eslint-disable-next-line no-console
    console.log(`[ActiveUploads] Removed active upload: ${strId}`, activeUploads);
  }
};

export const isActiveUpload = (id) => {
  if (!id) return false;
  const strId = String(id);
  const isActive = activeUploads.has(strId);
  // eslint-disable-next-line no-console
  console.log(`[ActiveUploads] Checking active upload: ${strId} -> ${isActive}`, activeUploads);
  return isActive;
};
